import { Component, OnInit } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { GoogleMapsService } from './services/google-maps.service';
import { AuthenticationService } from './services/authentication.service';
import { Store } from '@ngrx/store';
import { IAppState } from './store/app.state';
import { authLoginSuccess, getUser, getUserSuccess } from './store/actions/auth.actions';
import { ofType, Actions } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { IUserResponse } from './interfaces/auth.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleapisService } from './services/googleapis.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'MMT';
  display = false;
  displayInfo = false;
  current = '';
  user: IUserResponse;
  currentToken = '';
  subscription$ = this.authenticationService.token.subscribe(_ => {
    this.currentToken = this.authenticationService.currentTokenValue;
    if(this.authenticationService.currentTokenValue === 'publicToken') {
      this.displayInfo = true;
    }
  });

  userSubscription = this.actions$.pipe(
    ofType(getUserSuccess),
    tap(({ response }) => {
      this.user = response;
      this.currentToken = this.authenticationService.currentTokenValue;
    })
  ).subscribe();

  constructor(
    private location: Location,
    private googleMapsService: GoogleMapsService,
    private googleApisService: GoogleapisService,
    private authenticationService: AuthenticationService,
    private store$: Store<IAppState>,
    private actions$: Actions,
    private router: Router,
    private route: ActivatedRoute
  ) {
    location.onUrlChange(url => { this.urlChange(url.slice(1, url.length).replace('/', '_')) });
    this.store$.dispatch(getUser());
  }

  async ngOnInit() {
    if (!this.googleMapsService.isApiLoaded()) {
      await this.googleMapsService.loadApi();
    }

    if (!this.googleApisService.isApiLoaded()) {
      await this.googleApisService.loadApi();
    }
  }

  displayInformation() {
    this.displayInfo = true;
  }

  showSidebar() {
    this.display = true;
  }

  urlChange(url) {
    this.current = url;
  }

  logout(): void {
    this.authenticationService.logout();
  }
}
